// @ts-nocheck

import Validator from './validator'

export default class Form {

    protected _fields: any = {}
    protected _errors = []
    protected _touched = {}
    protected _blur = {};
    protected _isNewRecord = false;
    protected _subForms: { [name: string]: Form } = {}
    protected _events = {};

    public static readonly EVENT_BEFORE_UPDATE = "before-update";
    public static readonly EVENT_AFTER_UPDATE = "after-update";

    constructor(public readonly data = null) {
        this._fields = this.fields();
        this._subForms = this.subForms();
    }

    static create(data = null) {
        return new this(data).setIsNewRecord();
    }

    static load(data) {
        return new this(data);
    }

    setIsNewRecord() {
        this._isNewRecord = true;
        return this;
    }

    getIsNewRecord() {
        return this._isNewRecord;
    }

    fields() {
        return {};
    }

    subForms(): { [name: string]: Form } {
        return {};
    }

    watch(property: string, value: any, oldValue: any) {

    }

    rules(): Array<any> {
        return [];
    }

    validate(): Promise<boolean> {
        this.clearErrors();
        const p = [];
        p.push(Validator.execute(this));
        for (let name in this._subForms) {
            p.push(Validator.execute(this._subForms[name]));
        }
        return new Promise<boolean>((resolve) => {
            Promise.all(p).then((values) => {
                let v = true;
                values.forEach(isValid => {
                    v = v && isValid;
                })
                resolve(v);
            })
        });
    }

    get model() {
        return { ...this._fields, ...this.formsAs("model") };
    }

    get formData() {
        return { ...this._fields, ...this.formsAs("formData") };
    }

    get labels() {
        return {};
    }

    addError(name, message) {
        if (Object.keys(this._fields).includes(name) && !this._errors.find(item => item.name === name)) {
            this._errors.push({ name, message });
        } else {
            throw new Error(`Field "${name}" not exist in form "${this.constructor.name}".`);
        }
    }

    get errors() {
        return this._errors;
    }

    clearErrors(names = null) {
        if (!names) {
            this._errors = [];
        } else if (Array.isArray(names)) {
            names.forEach(name => {
                this._errors = this._errors.reduce((object, item: any) => {
                    if (item.name !== name) {
                        object.push(item)
                    }
                    return object
                }, [])
            })
        }
        for (let name in this._subForms) {
            this._subForms[name].clearErrors(names);
        }
    }

    touch(name: string): void {
        this._touched[name] = true;
        this._blur[name] = false;
    }

    touched(name: string): boolean {
        return this._touched[name] ?? false
    }

    blur(name: string): Promise<boolean> {
        this.clearErrors([name]);
        this._blur[name] = true;
        return Validator.execute(this, [name])
    }

    isBlur(name: string) {
        return this._blur[name] ?? null;
    }

    update(values): Promise<boolean> {
        this.dispatch(Form.EVENT_BEFORE_UPDATE);
        const names = [];
        for (const name in values) {
            if (Object.keys(this._fields).includes(name)) {
                const oldValue = (() => this._fields[name])()
                this._fields[name] = values[name];
                names.push(name);
                this.watch(name, values[name], oldValue);
            }
        }
        this.dispatch(Form.EVENT_AFTER_UPDATE);
        this.clearErrors(names);
        return Validator.execute(this, names);
    }

    get isValid() {
        let v = this._errors.length === 0
        for (let name in this._subForms) {
            v = v && this._subForms[name].isValid;
        }
        return v;
    }

    get isNewRecord() {
        return this.getIsNewRecord() || !this.data;
    }

    get forms(): { [name: string]: Form } {
        return this._subForms;
    }

    formsAs(property) {
        const out = {};
        for (let name in this._subForms) {
            out[name] = this._subForms[name][property];
        }
        return out;
    }

    on(eventName, callback) {
        this._events[eventName] ??= [];
        this._events[eventName].push(callback);
    }

    dispatch(eventName) {
        if (this._events[eventName]) {
            this._events[eventName].forEach(callback => {
                callback();
            })
        }
    }

}
